import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63c75270")

_pushScopeId("data-v-63c75270")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  ref: "modalWrapper",
  class: "modal-wrapper ion-overlay-wrapper"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "pause-modal-content" }
const _hoisted_5 = {
  key: 0,
  class: "pause-modal-content-section pause-modal-details"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "pause-modal-header" }, " Shop Paused Details ", -1)
const _hoisted_7 = {
  key: 1,
  class: "pause-modal-content-section"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Select Pause Option")
const _hoisted_9 = {
  key: 2,
  class: "pause-modal-content-section"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Select Pause Reason")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Other")
const _hoisted_12 = { class: "pause-modal-content-section" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "pause-modal-header" }, " Enter Your Cell Phone Number ", -1)
const _hoisted_14 = { class: "pause-modal-content-section pause-modal-btn" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_backdrop = _resolveComponent("ion-backdrop")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_list_header = _resolveComponent("ion-list-header")
  const _component_ion_radio = _resolveComponent("ion-radio")
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_content = _resolveComponent("ion-content")

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withId(() => [
      _withDirectives(_createVNode("div", _hoisted_1, [
        _createVNode(_component_ion_backdrop, {
          ref: "overlay",
          onClick: _ctx.closeModal
        }, null, 8, ["onClick"]),
        _createVNode("section", _hoisted_2, [
          _createVNode("header", _hoisted_3, [
            _createVNode("h2", { textContent: _ctx.text }, null, 8, ["textContent"]),
            _createVNode(_component_ion_button, {
              size: "small",
              fill: "transparent",
              class: "btn-close",
              onClick: _ctx.closeModal
            }, {
              default: _withId(() => [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: "/assets/icons/close.svg"
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_ion_content, {
            "scroll-y": true,
            class: "pause-modal-content-container"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_4, [
                (_ctx.isPaused && _ctx.pauseBlurb.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _hoisted_6,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pauseBlurb, (reason, index) => {
                        return (_openBlock(), _createBlock(_component_ion_item, { key: index }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(reason), 1 /* TEXT */)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isPaused)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode(_component_ion_list, { class: "pause-modal-options" }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_radio_group, {
                            value: "all",
                            modelValue: _ctx.type,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.type = $event))
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_list_header, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { class: "pause-modal-header" }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pauseOptions, (option, index) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  key: index,
                                  lines: "none"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(option), 1 /* TEXT */)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_radio, {
                                      mode: "md",
                                      color: "tertiary",
                                      slot: "start",
                                      value: option
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isPaused)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode(_component_ion_list, { class: "pause-modal-reasons" }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_radio_group, {
                            modelValue: _ctx.reason,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.reason = $event))
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_list_header, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { class: "pause-modal-header" }, {
                                    default: _withId(() => [
                                      _hoisted_10
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pauseReasons, (reason, index) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  key: index,
                                  lines: "none"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(reason), 1 /* TEXT */)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_radio, {
                                      mode: "md",
                                      color: "tertiary",
                                      slot: "start",
                                      value: reason
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128 /* KEYED_FRAGMENT */)),
                              _createVNode(_component_ion_item, { lines: "none" }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withId(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_radio, {
                                    mode: "md",
                                    color: "tertiary",
                                    slot: "start",
                                    value: "other"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _withDirectives(_createVNode(_component_ion_item, { class: "pause-modal-other-reason" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.otherReason,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.otherReason = $event)),
                                placeholder: "Other Reason"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                icon: "/assets/icons/keyboard.svg"
                              })
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.reason == 'other']
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_ion_item, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_input, {
                        modelValue: _ctx.employeeID,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.employeeID = $event)),
                        type: "number",
                        placeholder: "555-555-5555"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ion_icon, {
                        slot: "end",
                        icon: "/assets/icons/keyboard.svg"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_ion_button, {
                    size: "small",
                    class: { active: _ctx.isPaused },
                    onClick: _cache[5] || (_cache[5] = $event => (_ctx.setShopStatus()))
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.text), 1 /* TEXT */)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ])
            ]),
            _: 1
          })
        ], 512)
      ], 512), [
        [_vShow, _ctx.isOpen]
      ])
    ]),
    _: 1
  }))
})